import { createResourceHooks } from '@repo/api-client';
import { productClient } from './network';
import { type ProductTypeListItem, type ProductTypeDetail } from './types';

export const productHooks = createResourceHooks<
  ProductTypeListItem,
  ProductTypeDetail,
  any,
  any
>(productClient as any, ['products', 'types']);
